export function setCheckListDataToday(state, payload) {
  state.dataIsGetted = true;
  payload.forEach(module => {
    let criterion = [];
    let completeChild = true;
    module.checkList.forEach(criteria => {
      criteria['defParent'] = criteria['approvedParent'];
      criteria['defQualifiedParent'] = criteria['qualifiedParent'];
      criteria['defChild'] = criteria['approvedChild'];
      criterion.push(criteria);
      if (!criteria['defChild']) {
        completeChild = false;
      }
    });
    module.checkList = criterion;
    module.checkListComplete = completeChild;
  });
  state.checkListDataToday = payload;
}

export function saveCheckListData(state, payload) {
  let criterion = [];
  payload.forEach(element => {
    criterion.push({
      order: element.module.order,
      criteria: element.criterion
    });
    element.module['img'] = 'modules-0' + element.module.order;
    element.dates.forEach(date => {
      date.items.forEach(item => {
        item['defParent'] = item['approvedParent'];
        item['defQualifiedParent'] = item['qualifiedParent'];
        item['defChild'] = item['approvedChild'];
      });
    });
  });
  state.checkListData = payload;
  state.checkListCriteria = criterion;
}

export function saveCheckListDates(state, payload) {
  state.checkListDates = payload;
}

export function addCriteriaToCheckList(state, payload) {
  let moduleOrder = payload.moduleOrder;
  //console.log("moduleOrder", payload)
  payload.items.forEach(element => {
    element['defParent'] = element['approvedParent'] = false;
    element['defQualifiedParent'] = element['qualifiedParent'] = false;
    element['defChild'] = element['approvedChild'] = false;
  });
  //console.log("Payload items",payload.items)
  state.checkListData.forEach(element => {
    if (element.module.order == moduleOrder) {
      if (element.dates.length > 0) {
        payload.items.forEach(item => {
          element.dates[0].items.push(item);
        });
      } else {
        element.dates.push({ date: '-', items: payload.items });
      }
    }
  });
}

export function addCriteriaCreated(state, payload) {
  let checkData = payload;
  checkData['defParent'] = checkData['approvedParent'] = false;
  checkData['defQualifiedParent'] = checkData['qualifiedParent'] = false;
  checkData['defChild'] = checkData['approvedChild'] = false;
  state.checkListData.forEach(element => {
    if (element.module.order == checkData.moduleOrder) {
      if (element.dates.length > 0) {
        element.dates[0].items.push(checkData);
      } else {
        element.dates.push({ date: '-', items: [checkData] });
      }
    }
  });
}

export function removeItemFromList(state, data) {
  state.checkListData.forEach(element => {
    if (element.module.order == data.order) {
      //console.log("itemId", data.itemId)
      let indexSelected = -1;
      let index = -1;
      element.dates[0].items.forEach(check => {
        index++;
        if (check.id == data.itemId) {
          indexSelected = index;
        }
      });
      if (indexSelected != -1) {
        element.dates[0].items.splice(indexSelected, 1);
      }
      //console.log("after", element.dates[0].items)
    }
  });
}

export function setCheckListDataPending(state, payload) {
  state.checkListDataPending = payload;
}

export function setCheckListCriteria(state, payload) {
  state.checkListCriteria = payload;
}

export function setSelectedModule(state, Mid) {
  state.idSelectedModule = Mid;
}

export function addDataToCheckList(state, data) {
  for (var key in state.checkListData) {
    if (state.checkListData.hasOwnProperty(key)) {
      let element = state.checkListData[key];
      if (element.Order == data.order) {
        data.items.forEach(dataItem => {
          element.checkList.push(dataItem);
        });
      }
    }
  }
}

export function error(state, payload) {
  //console.log("Error", payload)
  state.error = true;
  state.errorMessage = payload;
}

export function cleanErrors(state) {
  state.error = false;
  state.errorMessage = '';
}

export function resetCount(state, { moduleIndex, items}) {
  items = items.map(idObject => idObject.id);

  state.checkListData[moduleIndex].dates[0].items.map(item => {
    if (items.includes(item.id)) item.count = 0;

    return item;
  });
}
